import * as Actions from './CreatePromoCodeActionTypes';

export const createPromoCodeReducer = (
  state = {
    promoCodeCreate: {
      loading: false,
      error: { status: false, message: '' },
      data: null
    },

    promoCodes: {
    loading: false,
    error: { status: false, message: '' },
    data: []
  }
  },
  action
) => {
  switch (action.type) {
    
    case Actions.CREATE_PROMO_CODE:
      return {
        ...state,
        promoCodeCreate: {
          ...state.promoCodeCreate,
          loading: true,
          error: { status: false, message: '' }
        }
      };
      
    case Actions.CREATE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        promoCodeCreate: {
          ...state.promoCodeCreate,
          loading: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };
      
    case Actions.CREATE_PROMO_CODE_FAILS:
      return {
        ...state,
        promoCodeCreate: {
          ...state.promoCodeCreate,
          loading: false,
          error: { status: true, message: action.payload }
        }
      };

      case Actions.FETCH_PROMO_CODES:
      return {
        ...state,
        promoCodes: {
          ...state.promoCodes,
          loading: true,
          error: { status: false, message: '' }
        }
      };
      
    case Actions.FETCH_PROMO_CODES_SUCCESS:
      return {
        ...state,
        promoCodes: {
          ...state.promoCodes,
          loading: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_PROMO_CODES_FAILS:
      return {
        ...state,
        promoCodes: {
          ...state.promoCodes,
          loading: false,
          error: { status: true, message: action.payload }
        }
      };
      
    default:
      return state;
  }
};